module.exports = __webpack_public_path__ + "static/media/logo.3677a7b7.svg";